import React, { useMemo, useContext } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { FlexMiddle, Tooltip, ExtraSmall } from '@ubeya/shared-web/components';
import { ReactComponent as BreakIcon } from '@ubeya/shared-web/assets/break.svg';
import { ReactComponent as AddIcon } from '@ubeya/shared-web/assets/plus.svg';
import { media } from '@ubeya/shared-web/style';
import { ReactComponent as WarningIcon } from '@ubeya/shared-web/assets/error.svg';
import { isReadOnly } from 'shared/utils/timesheet';

const sortByTime = (a, b) => moment(a.startTime).format('HHmm') - moment(b.startTime).format('HHmm');

const Wrapper = styled(FlexMiddle)`
  height: 60px;

  > svg {
    margin-right: 7px;
    ${media.desktop`margin-right: 20px;`}
  }
`;

const Description = styled.span``;

const BreakButton = styled(BreakIcon)`
  &:hover {
    > g {
      > circle {
        fill: ${({ theme }) => theme.colors.grey1};
      }
      > path {
        stroke: ${({ theme }) => theme.colors.disabled};
      }
    }
  }
`;

const AddButton = styled(AddIcon)`
  &:hover {
    > g {
      rect {
        fill: ${({ theme }) => theme.colors.primary};
      }
      path {
        stroke: ${({ theme }) => theme.colors.white};
      }
    }
  }
`;

const DetailsRenderer = ({ rowData, columnData }) => {
  const { t } = useContext(ConfigContext);
  const { timeFormat } = useContext(ConfigContext);
  const { onShiftClick, readOnly = false } = columnData || {};

  const breaksContent = useMemo(
    () =>
      (rowData?.breaktimes || []).sort(sortByTime).map(({ id, startTime, endTime, comments }) => (
        <ExtraSmall key={id}>
          <span>{comments}</span>

          <Description>
            {startTime && moment(startTime).isValid() ? moment(startTime).format(timeFormat) : ''}
            {endTime && moment(endTime).isValid() ? ` - ${moment(endTime).format(timeFormat)}` : ` - ${t('onBreak')}`}
          </Description>
        </ExtraSmall>
      )),
    [timeFormat, t, rowData?.breaktimes]
  );

  if (rowData?.subRows || rowData?.summarized || rowData?.isExternal) {
    return <></>;
  }

  return (
    <Wrapper>
      {rowData.warnings?.length > 0 && (
        <Tooltip body={rowData.warnings.map(({ slug }) => t(slug))}>
          <WarningIcon />
        </Tooltip>
      )}

      {rowData.breaktimes?.length ? (
        <Tooltip body={breaksContent}>
          <BreakButton />
        </Tooltip>
      ) : null}

      {!rowData.dummy && !isReadOnly(rowData, readOnly) && (
        <Tooltip body={t('add')}>
          <AddButton className="editable" onClick={() => onShiftClick(rowData)} />
        </Tooltip>
      )}
    </Wrapper>
  );
};

export default DetailsRenderer;
